export default "__VITE_ASSET__BZMNOsDf__"